import { render, staticRenderFns } from "./RootTemplate.vue?vue&type=template&id=2287cf2f&scoped=true&"
var script = {}
import style0 from "./RootTemplate.vue?vue&type=style&index=0&id=2287cf2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287cf2f",
  null
  
)

export default component.exports